<template lang="pug">
    .view-button-wrapper
        .view-button-item(v-for="view in views" :key="view")
            .fa.view-button-item-button(
                :class="[activeView === view ? 'active' : '', view === 'grid' ? 'fa-table' : 'fa-bars']"
                @click="setView(view)"
            )
</template>

<script>
export default {
  name: "ViewButton",
  data() {
    return {
      views: ["list", "grid"],
      activeView: "list",
    };
  },
  watch: {
    "$route.query.view": {
      immediate: true,
      handler(newVal) {
        if (newVal && this.views.includes(newVal)) {
          this.activeView = newVal;
        } else {
          this.activeView = "list";
        }
      },
    },
  },
  methods: {
    setView(view) {
      if (this.activeView !== view) {
        this.activeView = view;
        this.$updateQuery({ view });
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.view-button-wrapper
  display inline-flex
  border 1px solid button-background-color
  border-radius 3px
  overflow hidden
  background #f4f8fb
  .view-button-item
    .view-button-item-button
      font-size 20px
      width 32px
      height 32px
      display flex
      align-items center
      justify-content center
      color #fff
      background button-background-color
      cursor pointer
      transition background 0.2s, color 0.2s
      &.active
        background button-background-color
        color #fff
      &:not(.active)
        background #fff
        color button-background-color
      &:hover
        background button-background-color
        color #fff
</style>
